(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3480],{

/***/ 68001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77423);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);




var ConfirmationModal = function ConfirmationModal(_ref) {
  var title = _ref.title,
      children = _ref.children,
      className = _ref.className,
      okText = _ref.okText,
      cancelText = _ref.cancelText,
      visible = _ref.visible,
      onOk = _ref.onOk,
      onCancel = _ref.onCancel,
      width = _ref.width;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    centered: true,
    cancelText: cancelText,
    className: className,
    okText: okText,
    title: title || 'Are you sure?',
    visible: visible,
    width: width || 550,
    onCancel: onCancel,
    onOk: onOk,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ConfirmationModal);

/***/ }),

/***/ 44669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ subscription_plans; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(52746);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__(29051);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ../../node_modules/antd/es/typography/index.js + 23 modules
var typography = __webpack_require__(95356);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/@evenfinancial/finance-client/dist/index.js
var dist = __webpack_require__(54580);
// EXTERNAL MODULE: ../../node_modules/@blueprintjs/popover2/lib/esm/tooltip2.js + 1 modules
var tooltip2 = __webpack_require__(67983);
// EXTERNAL MODULE: ../../libs/ui-lib/src/styles/variables.ts
var variables = __webpack_require__(86517);
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/_atomics/Button/EvenButton.tsx
var EvenButton = __webpack_require__(24682);
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/SubscriptionPlanCard/SubscriptionPlanCard.scss
var SubscriptionPlanCard = __webpack_require__(14383);
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/_atomics/FontAwesomeIcon/FontAwesomeKitIcon.tsx
var FontAwesomeKitIcon = __webpack_require__(25886);
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/_atomics/FontAwesomeIcon/types.ts
var types = __webpack_require__(29602);
// EXTERNAL MODULE: ../../libs/ui-lib/src/lib/SubscriptionPlanCard/types.ts
var SubscriptionPlanCard_types = __webpack_require__(19590);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui-lib/src/lib/SubscriptionPlanCard/SubscriptionPlanCard.tsx


var _icons;















var renderFeatureBoolean = function renderFeatureBoolean(showCheck) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
    icon: showCheck ? pro_solid_svg_icons/* faCheck */.LEp : pro_solid_svg_icons/* faXmark */.g82,
    style: {
      height: 'auto',
      width: 8
    }
  });
};

var planIconStyle = {
  height: 'auto',
  width: 24
};
var icons = (_icons = {}, (0,defineProperty/* default */.Z)(_icons, dist.AccountTierType.Starter, /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
  icon: pro_solid_svg_icons/* faRocket */.tMT,
  style: planIconStyle
})), (0,defineProperty/* default */.Z)(_icons, dist.AccountTierType.Growth, /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
  icon: pro_solid_svg_icons/* faSeedling */.YKZ,
  style: planIconStyle
})), (0,defineProperty/* default */.Z)(_icons, dist.AccountTierType.Scale, /*#__PURE__*/(0,jsx_runtime.jsx)(FontAwesomeKitIcon/* FontAwesomeKitIcon */.J, {
  icon: types/* KitIconNames.Signal */.Im.Signal,
  style: planIconStyle
})), _icons);
var SubscriptionPlanCard_SubscriptionPlanCard = function SubscriptionPlanCard(_ref) {
  var plan = _ref.plan;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("article", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()('subscription-plan', plan.id, plan.cardClassName),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
          className: classnames_default()('subscription-plan-header', plan.cardClassName),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: classnames_default()('fa-layers', 'fa-fw', 'fa-4x', 'subscription-plan-header-icon'),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
              color: variables/* colors.white */.O.white,
              icon: pro_solid_svg_icons/* faCircle */.diR,
              style: {
                height: 'auto',
                width: 58
              }
            }), icons[plan.id]]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            className: "subscription-plan-name",
            role: "plan-name",
            children: plan.name
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          className: "subscription-plan-triangle",
          viewBox: "0 0 280 20",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            d: "M140 20L0 0h280z"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
          className: "subscription-plan-subheader",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
            className: "subscription-plan-info",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "subscription-plan-value",
              children: plan.planFee
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
              className: "subscription-plan-label",
              children: "Monthly Platform Fee"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
            className: "subscription-plan-info",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: classnames_default()('subscription-plan-subvalue', 'two-lines'),
              role: "seat-numbers",
              children: plan.pricing
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h6", {
              className: "subscription-plan-label",
              children: ["Dynamic Real Time Pricing (Personal Loans Only)", /*#__PURE__*/(0,jsx_runtime.jsx)("sup", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "1"
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
            className: "subscription-plan-info",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: "subscription-plan-subvalue-small",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: plan.productOffersLevel
              }), " Product Offers Available"]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "subscription-plan-icons",
              role: "tooltip",
              children: plan.integrations.map(function (_ref2, index) {
                var icon = _ref2.icon,
                    title = _ref2.title;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(tooltip2/* Tooltip2 */.u, {
                  content: title,
                  position: "right",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: icon,
                    style: planIconStyle
                  })
                }, index);
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h6", {
              className: "subscription-plan-label",
              children: ["Available Integrations", /*#__PURE__*/(0,jsx_runtime.jsx)("sup", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "2"
                })
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "subscription-plan-info",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "subscription-plan-subvalue",
              role: "seat-number",
              children: plan.seatsNumber
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h6", {
              className: "subscription-plan-label",
              children: ["Even Tools Seats Included", /*#__PURE__*/(0,jsx_runtime.jsx)("sup", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "3"
                })
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "subscription-plan-features",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "value",
              children: renderFeatureBoolean(plan.features[SubscriptionPlanCard_types/* FeatureKey.dedicatedPartnerManager */.A.dedicatedPartnerManager])
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
              className: "label",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Dedicated Partner Manager"
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(EvenButton/* EvenButton */.Z, {
          large: true,
          className: "subscription-plan-activate-button",
          disabled: plan === null || plan === void 0 ? void 0 : plan.isDisabled,
          outlined: plan.actionButtonType === 'outlined',
          role: "button",
          tertiary: plan.actionButtonTertiary,
          onClick: plan.onActionButtonClick,
          children: plan.actionButtonTitle
        })]
      })
    })
  });
};
// EXTERNAL MODULE: ./components/confirmation-modal/index.tsx
var confirmation_modal = __webpack_require__(68001);
// EXTERNAL MODULE: ./pages/self-service/account/tabs/subscription/states/free-subscription.tsx
var free_subscription = __webpack_require__(47252);
// EXTERNAL MODULE: ./resources/saas/selects.ts
var selects = __webpack_require__(51033);
// EXTERNAL MODULE: ./resources/self-service/payment/util-methods.ts
var util_methods = __webpack_require__(36980);
// EXTERNAL MODULE: ./resources/self-service/selects.ts
var self_service_selects = __webpack_require__(36453);
// EXTERNAL MODULE: ./resources/supply-migration/helpers.ts
var helpers = __webpack_require__(50941);
// EXTERNAL MODULE: ./resources/supply-migration/selects.ts
var supply_migration_selects = __webpack_require__(34607);
;// CONCATENATED MODULE: ./components/subscription-plans/index.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var Text = typography/* default.Text */.Z.Text;

var getAvailablePlans = function getAvailablePlans(planTypes, currentPlan, currentSubscription, supplyMigration) {
  var tiersToRemove = [];

  var showTier = function showTier(currentTier, previousTier) {
    return (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.tier) === previousTier || (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.tier) === currentTier && (currentSubscription === null || currentSubscription === void 0 ? void 0 : currentSubscription.deletedAt);
  };

  var isPermanent = (0,helpers/* isPermanentTrial */.xT)(supplyMigration);
  var showStarter = showTier(dist.AccountTierType.Starter, undefined);
  var showGrowth = showStarter || showTier(dist.AccountTierType.Growth, dist.AccountTierType.Starter);
  var showScale = showGrowth || showTier(dist.AccountTierType.Scale, dist.AccountTierType.Growth);

  if (!showStarter) {
    tiersToRemove.push(dist.AccountTierType.Starter);
  }

  if (!showGrowth) {
    tiersToRemove.push(dist.AccountTierType.Growth);
  }

  if (!showScale) {
    tiersToRemove.push(dist.AccountTierType.Scale);
  }

  if (supplyMigration !== null && supplyMigration !== void 0 && supplyMigration.tier) {
    tiersToRemove.push.apply(tiersToRemove, (0,toConsumableArray/* default */.Z)((0,util_methods/* getPreviousTiers */.Y_)(supplyMigration.tier)));

    if (isPermanent) {
      tiersToRemove.push(supplyMigration.tier);
    }
  }

  return planTypes.map(function (planType) {
    if (!tiersToRemove.includes(planType.id)) {
      return planType;
    }

    var actionButtonTitle = planType.id === (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.tier) ? 'Current plan' : 'Unavailable';
    var isDisabled = planType.id !== (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.tier);
    return _objectSpread(_objectSpread({}, planType), {}, {
      actionButtonTitle: actionButtonTitle,
      cardClassName: "".concat(planType.cardClassName, " unavailable"),
      isDisabled: isDisabled,
      onActionButtonClick: undefined
    });
  });
};

var SubscriptionPlans = function SubscriptionPlans(_ref) {
  var currentPlan = _ref.currentPlan,
      currentSubscription = _ref.currentSubscription;
  var firstRolloutOnboarding = (0,es/* useSelector */.v9)(self_service_selects/* selectIsFirstRolloutOnboarding */.Mb);
  var implementationFeeWaived = (0,es/* useSelector */.v9)(self_service_selects/* selectIsImplementationFeeWaived */.aF);
  var lastPurchasedSubscription = (0,es/* useSelector */.v9)(selects/* selectLastPurchasedSubscription */.p);
  var saasPlans = (0,es/* useSelector */.v9)(selects/* selectSaasPlansForAccountSubscription */.k);
  var supplyMigration = (0,es/* useSelector */.v9)(supply_migration_selects/* selectSaasMigrationSettings */.V);

  var _useState = (0,react.useState)(false),
      growthPlanModalVisible = _useState[0],
      setGrowthPlanModalVisible = _useState[1];

  var _useRouter = (0,router.useRouter)(),
      _useRouter$query = _useRouter.query,
      integrationId = _useRouter$query.id,
      submit = _useRouter$query.submit;

  var isSubmitForReview = Boolean(submit);
  var findMigrationPlan = !currentSubscription && Boolean(supplyMigration) && !(0,helpers/* isPermanentTrial */.xT)(supplyMigration);
  var plans = (0,free_subscription.getPlans)(saasPlans, implementationFeeWaived, firstRolloutOnboarding, findMigrationPlan, supplyMigration, currentSubscription, currentPlan, lastPurchasedSubscription, integrationId, isSubmitForReview);
  var plansAvailable = getAvailablePlans(plans, currentPlan, currentSubscription, supplyMigration);
  var growthPlan = plansAvailable.find(function (plan) {
    return plan.id === dist.AccountTierType.Growth;
  });

  if (growthPlan && (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.tier) === dist.AccountTierType.Starter) {
    growthPlan.actionButtonTitle = 'Upgrade';

    growthPlan.onActionButtonClick = function () {
      setGrowthPlanModalVisible(true);
    };
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(confirmation_modal/* default */.Z, {
      cancelText: "Close",
      okText: "Next",
      title: "Upgrade to growth",
      visible: growthPlanModalVisible,
      onCancel: function onCancel() {
        return setGrowthPlanModalVisible(false);
      },
      onOk: function onOk() {
        router_default().push("/purchase-plan?plan=".concat(dist.AccountTierType.Growth));
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
        children: "Upgrade will cancel your existing subscription once you purchase a new plan. If you had leftover amount from existing plan that was prepaid, it will be deducted from your total when you purchase the new plan."
      })
    }), isSubmitForReview && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "subscription-text",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Text, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
          icon: pro_solid_svg_icons/* faCircleInfo */.DBf,
          style: {
            height: 16,
            width: 16
          }
        }), ' ', "You must purchase a plan before submitting your integration for review."]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "subscription-plans",
      children: plansAvailable.map(function (plan, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(SubscriptionPlanCard_SubscriptionPlanCard, {
          currentPlan: currentPlan,
          plan: plan
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "integration-options",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "integration-options-header",
        children: "Integration Fees"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "integration-options-body",
        children: plans.map(function (_ref2, index) {
          var Icon = _ref2.optionIcon,
              optionName = _ref2.optionName,
              optionFee = _ref2.optionFee;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "integration-option",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: classnames_default()({
                waived: implementationFeeWaived && optionName !== 'Native'
              }),
              children: optionFee
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
                children: Icon
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                children: [optionName, /*#__PURE__*/(0,jsx_runtime.jsx)("sup", {
                  children: "4"
                })]
              })]
            })]
          }, index);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "subscription-plans-footnote",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Other business models and terms applicable per financial product vertical and tier"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Implementation fee applies per-integration"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Fee applies for additional seats"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Each integration must receive Compliance approval prior to going live. Any requested changes must be implemented and then reviewed by Even\u2019s Compliance team. Should you not wish to continue or make the requested changes, your subscription will terminate. The Monthly Platform Fee is nonrefundable."
        })]
      })
    })]
  });
};

/* harmony default export */ var subscription_plans = (SubscriptionPlans);

/***/ }),

/***/ 47252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getPlans": function() { return /* binding */ getPlans; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(54933);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);
/* harmony import */ var lodash_startCase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74600);
/* harmony import */ var lodash_startCase__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_startCase__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54580);
/* harmony import */ var _evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _portal_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27656);
/* harmony import */ var _portal_common__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_portal_common__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _portal_ui_lib__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19590);
/* harmony import */ var _components_subscription_plans__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44669);
/* harmony import */ var _resources_self_service_payment_util_methods__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36980);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52322);











var iconStyle = {
  height: 'auto',
  width: 24
};

var IconPartnerPage = function IconPartnerPage() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
    icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faDisplayCode */ .NZX,
    style: iconStyle
  });
};

var IconEmbed = function IconEmbed() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
    icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faCube */ .hGM,
    style: iconStyle
  });
};

var IconNative = function IconNative() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
    icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faCode */ .dT$,
    style: iconStyle
  });
};

var getPlans = function getPlans(saasPlans, implementationFeeWaived, firstRolloutOnboarding, findMigrationPlan, supplyMigration, currentSubscription, currentPlan, lastPurchasedSubscription, integrationId, submit) {
  var _currentPlanDisplayDa, _starterTierPlan$seat, _currentPlanDisplayDa2, _growthTierPlan$seatL;

  var starterTierPlan = (0,_resources_self_service_payment_util_methods__WEBPACK_IMPORTED_MODULE_7__/* .findDefaultSaasPlanByWhitelist */ .kE)(saasPlans, _evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Starter, implementationFeeWaived, firstRolloutOnboarding, findMigrationPlan && (supplyMigration === null || supplyMigration === void 0 ? void 0 : supplyMigration.tier) === _evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Starter);
  var growthTierPlan = (0,_resources_self_service_payment_util_methods__WEBPACK_IMPORTED_MODULE_7__/* .findDefaultSaasPlanByWhitelist */ .kE)(saasPlans, _evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Growth, implementationFeeWaived, firstRolloutOnboarding, findMigrationPlan && (supplyMigration === null || supplyMigration === void 0 ? void 0 : supplyMigration.tier) === _evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Growth);
  var migrationTierPlan = !currentSubscription && supplyMigration && (0,_resources_self_service_payment_util_methods__WEBPACK_IMPORTED_MODULE_7__/* .findDefaultSaasPlanByWhitelist */ .kE)(saasPlans, supplyMigration.tier, implementationFeeWaived, firstRolloutOnboarding, findMigrationPlan);
  var currentPlanDisplayData = supplyMigration && currentPlan ? (0,_resources_self_service_payment_util_methods__WEBPACK_IMPORTED_MODULE_7__/* .currentPlanSubscriptionData */ .Yc)(currentPlan) : undefined;
  var isMigrationScaleUser = (supplyMigration === null || supplyMigration === void 0 ? void 0 : supplyMigration.tier) === _evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Scale;
  var showPickAPlan = false;

  if (isMigrationScaleUser && !lastPurchasedSubscription) {
    showPickAPlan = true;
  }

  var submitQuery = integrationId && submit ? "&id=".concat(integrationId, "&submit=true") : '';
  return [{
    actionButtonTitle: 'Pick Plan',
    actionButtonType: _portal_ui_lib__WEBPACK_IMPORTED_MODULE_10__/* .ActionButtonType.PRIMARY */ .m.PRIMARY,
    cardClassName: 'starter',
    features: {
      dedicatedPartnerManager: false
    },
    id: _evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Starter,
    integrations: [{
      icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faDisplayCode */ .NZX,
      title: 'Partner Page'
    }],
    name: lodash_startCase__WEBPACK_IMPORTED_MODULE_2___default()(_evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Starter),
    onActionButtonClick: function onActionButtonClick() {
      next_router__WEBPACK_IMPORTED_MODULE_3___default().push("/purchase-plan?plan=".concat(_evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Starter).concat(submitQuery));
    },
    optionFee: starterTierPlan ? (0,_portal_common__WEBPACK_IMPORTED_MODULE_5__.moneyFormatter)((_currentPlanDisplayDa = currentPlanDisplayData === null || currentPlanDisplayData === void 0 ? void 0 : currentPlanDisplayData.partnerPageImplementationFee) !== null && _currentPlanDisplayDa !== void 0 ? _currentPlanDisplayDa : (0,_resources_self_service_payment_util_methods__WEBPACK_IMPORTED_MODULE_7__/* .getSaasFeeReasonPrice */ .EV)(_evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.SaasFeeReason.PartnerPageImplementation, migrationTierPlan || starterTierPlan)) : 'n/a',
    optionIcon: IconPartnerPage,
    optionName: 'Partner Page',
    planFee: starterTierPlan ? (0,_portal_common__WEBPACK_IMPORTED_MODULE_5__.moneyFormatter)((currentPlanDisplayData === null || currentPlanDisplayData === void 0 ? void 0 : currentPlanDisplayData.monthlyFeeStarter) || starterTierPlan.monthlyFee) : 'n/a',
    pricing: 'You Earn Up To $300 Per-Lead',
    productOffersLevel: 'Limited',
    seatsNumber: (starterTierPlan === null || starterTierPlan === void 0 ? void 0 : (_starterTierPlan$seat = starterTierPlan.seatLimit) === null || _starterTierPlan$seat === void 0 ? void 0 : _starterTierPlan$seat.toString()) || '1'
  }, {
    actionButtonTitle: 'Pick Plan',
    actionButtonType: _portal_ui_lib__WEBPACK_IMPORTED_MODULE_10__/* .ActionButtonType.PRIMARY */ .m.PRIMARY,
    cardClassName: 'growth',
    features: {
      dedicatedPartnerManager: false
    },
    id: _evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Growth,
    integrations: [{
      icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faDisplayCode */ .NZX,
      title: 'Partner Page'
    }, {
      icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faCube */ .hGM,
      title: 'Embed'
    }],
    name: lodash_startCase__WEBPACK_IMPORTED_MODULE_2___default()(_evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Growth),
    onActionButtonClick: function onActionButtonClick() {
      next_router__WEBPACK_IMPORTED_MODULE_3___default().push("/purchase-plan?plan=".concat(_evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Growth).concat(submitQuery));
    },
    optionFee: growthTierPlan ? (0,_portal_common__WEBPACK_IMPORTED_MODULE_5__.moneyFormatter)((_currentPlanDisplayDa2 = currentPlanDisplayData === null || currentPlanDisplayData === void 0 ? void 0 : currentPlanDisplayData.embedImplementationFee) !== null && _currentPlanDisplayDa2 !== void 0 ? _currentPlanDisplayDa2 : (0,_resources_self_service_payment_util_methods__WEBPACK_IMPORTED_MODULE_7__/* .getSaasFeeReasonPrice */ .EV)(_evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.SaasFeeReason.EmbedImplementation, migrationTierPlan || growthTierPlan)) : 'n/a',
    optionIcon: IconEmbed,
    optionName: 'Embed',
    planFee: growthTierPlan ? (0,_portal_common__WEBPACK_IMPORTED_MODULE_5__.moneyFormatter)((currentPlanDisplayData === null || currentPlanDisplayData === void 0 ? void 0 : currentPlanDisplayData.monthlyFeeGrowth) || growthTierPlan.monthlyFee) : 'n/a',
    pricing: 'You Earn Up To $300 Per-Lead',
    productOffersLevel: 'Advanced',
    seatsNumber: (growthTierPlan === null || growthTierPlan === void 0 ? void 0 : (_growthTierPlan$seatL = growthTierPlan.seatLimit) === null || _growthTierPlan$seatL === void 0 ? void 0 : _growthTierPlan$seatL.toString()) || '2'
  }, {
    actionButtonTertiary: true,
    actionButtonTitle: showPickAPlan ? 'Pick Plan' : 'Contact Us',
    actionButtonType: _portal_ui_lib__WEBPACK_IMPORTED_MODULE_10__/* .ActionButtonType.OUTLINED */ .m.OUTLINED,
    cardClassName: 'scale',
    features: {
      dedicatedPartnerManager: true
    },
    id: _evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Scale,
    integrations: [{
      icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faDisplayCode */ .NZX,
      title: 'Partner Page'
    }, {
      icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faCube */ .hGM,
      title: 'Embed'
    }, {
      icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_9__/* .faCode */ .dT$,
      title: 'Native'
    }],
    name: lodash_startCase__WEBPACK_IMPORTED_MODULE_2___default()(_evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Scale),
    onActionButtonClick: function onActionButtonClick() {
      showPickAPlan ? next_router__WEBPACK_IMPORTED_MODULE_3___default().push("/purchase-plan?plan=".concat(_evenfinancial_finance_client__WEBPACK_IMPORTED_MODULE_4__.AccountTierType.Scale).concat(submitQuery)) : next_router__WEBPACK_IMPORTED_MODULE_3___default().push('/account/upgrade-scale');
    },
    optionFee: 'Contact Us',
    optionIcon: IconNative,
    optionName: 'Native',
    planFee: isMigrationScaleUser && migrationTierPlan ? (0,_portal_common__WEBPACK_IMPORTED_MODULE_5__.moneyFormatter)(migrationTierPlan.monthlyFee) : 'Custom Pricing',
    pricing: 'Custom',
    productOffersLevel: 'Full',
    seatsNumber: isMigrationScaleUser ? 'Unlimited' : 'Custom'
  }];
};

var FreeSubscriptionState = function FreeSubscriptionState() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_subscription_plans__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {});
};

/* harmony default export */ __webpack_exports__["default"] = (FreeSubscriptionState);

/***/ }),

/***/ 19590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ FeatureKey; },
/* harmony export */   "m": function() { return /* binding */ ActionButtonType; }
/* harmony export */ });
var FeatureKey;

(function (FeatureKey) {
  FeatureKey["dedicatedPartnerManager"] = "dedicatedPartnerManager";
})(FeatureKey || (FeatureKey = {}));

var ActionButtonType;
/** @deprecated */

(function (ActionButtonType) {
  ActionButtonType["DASHED"] = "dashed";
  ActionButtonType["OUTLINED"] = "outlined";
  ActionButtonType["PRIMARY"] = "primary";
})(ActionButtonType || (ActionButtonType = {}));

/***/ }),

/***/ 14383:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);